<template>
    <div id="app" class="full-height" :class="'background-' + (background || 'none') + ' app-' + (appSegment || 'none')">
        <keep-alive>
            <api-client></api-client>
        </keep-alive>
        <notifications id="notification-container"></notifications>
        <div class="router-view-container">
            <router-view class="router-view" />
        </div>
    </div>
</template>

<script>
    import ApiClient from '@/components/app-components/api-client'
    import Vue from 'vue'
    import Notify from 'vue-notifyjs'
    import VueTextareaAutosize from 'vue-textarea-autosize'
    import { mapGetters } from 'vuex';
    import Config from '@/config';
    import * as MutationTypes from '@/store/mutation-types';

    Vue.use(Notify)
    Vue.use(VueTextareaAutosize)

    export default {
        name: 'app',
        components: {
            ApiClient
        },
        computed: {
            ...mapGetters({
                background: 'getCurrentBackground',
                appSegment: 'getCurrentAppSegment',
            })
        },
        created() {
            this.$store.commit(MutationTypes.SET_APP_CONFIG, Config);
        },
    }
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
    @import url('https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap');

    @import "@/styles/mixins.scss";

    html, body {
        height: 100%;
        background: #0a0a0a !important;
    }

    #app {
        font-family: Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-height: 100%;

        &.app-frontend {
            background: #0a0a0a;

            min-height: auto;
            width: 1366px;
            height: 768px;
            overflow: hidden;

            @include alignCenter;
        }

        border: 1px solid #333333;

        background: white no-repeat fixed;
        background-size: cover;

        &.background-login {
            background-image: url("~@/assets/general/login-bg.jpg");
        }
    }

    .btn {
        &.disabled, &:disabled {
            opacity: .25 !important;
        }

        &.btn-frontex {
            border-width: 3px;
            border-top-color: #E4F2FC;
            border-right-color: #AFDCF3;
            border-bottom-color: #3394C1;
            border-left-color: #337FA5;
            padding: 15px 35px;
            background: #33A9DD;
            color: white !important;
            text-transform: uppercase;
            font-size: 20pt;
            font-family: Trebuchet MS,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Tahoma,sans-serif;

            &, &:hover, &:active, &:focus {
                outline: none !important;
            }

            &:hover {
                border-top-color: lighten(#E4F2FC, 10%);
                border-right-color: lighten(#AFDCF3, 10%);
                border-bottom-color: lighten(#3394C1, 10%);
                border-left-color: lighten(#337FA5, 10%);
                background: lighten(#33a9dd, 10%);
            }

            &:active, &:focus {
                border-top-color: darken(#E4F2FC, 20%);
                border-right-color: darken(#AFDCF3, 20%);
                border-bottom-color: darken(#3394C1, 20%);
                border-left-color: darken(#337FA5, 20%);
                background: darken(#33a9dd, 20%);
            }
        }
    }

    .router-view-container, .router-view {
        height: 100%;
    }

    #notification-container .alert {
        z-index: 9999999;
    }

    .frontline-title {
        width: 80%;
        margin-top: 40px;
        margin-bottom: 100px;
    }

    .frontex-logo-bottom-left {
        position: absolute;
        bottom: 15px;
        left: 15px;
    }

    @import "../node_modules/animate.css/animate.css";
</style>